import { useContext } from 'react';
import { AddressContext } from './Address';

export default () => useContext(AddressContext);
